/* KB About – Colour Explosion */
(function(){
'use strict';
function kbaInit(root){
  if (!root || root.dataset.kbaInit) return;
  root.dataset.kbaInit = '1';
  root.classList.add('kba--js');

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var css = getComputedStyle(root);
  var PAL = ['--c1','--c2','--c3','--c4','--c5','--c6'].map(function(v){ return css.getPropertyValue(v).trim() || '#8AA6E5'; });
  function hexRgb(h){ h = h.replace('#',''); if (h.length === 3) h = h.replace(/./g, '$&$&'); var n = parseInt(h,16); return [(n>>16)&255,(n>>8)&255,n&255]; }
  var PALRGB = PAL.map(hexRgb);
  function rnd(a,b){ return a + Math.random()*(b-a); }
  function pick(a){ return a[Math.floor(Math.random()*a.length)]; }
  function clamp(v,a,b){ return v < a ? a : v > b ? b : v; }
  function onView(el, cb, opts){
    if (!el) return;
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ cb(e); io.unobserve(e.target); } }); }, opts || {threshold:.25});
    io.observe(el);
  }

  /* ================= HERO ================= */
  var hero = root.querySelector('.kba-hero');
  (function heroInit(){
    if (!hero) return;
    // split heading into letters (keeps words together, keeps an accessible label)
    var h = hero.querySelector('.kba-hero__h');
    var label = h.textContent.replace(/\s+/g,' ').trim();
    var idx = 0;
    function splitNode(node){
      Array.prototype.slice.call(node.childNodes).forEach(function(c){
        if (c.nodeType === 3){
          var frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function(w){
            if (!w) return;
            if (/^\s+$/.test(w)){ frag.appendChild(document.createTextNode(' ')); return; }
            var ws = document.createElement('span'); ws.className = 'kba-w8';
            w.split('').forEach(function(ch){ var s = document.createElement('span'); s.className = 'kba-ch'; s.textContent = ch; s.style.setProperty('--i', idx++); ws.appendChild(s); });
            frag.appendChild(ws);
          });
          node.replaceChild(frag, c);
        } else if (c.nodeType === 1){ splitNode(c); }
      });
    }
    splitNode(h);
    h.setAttribute('aria-label', label);
    Array.prototype.forEach.call(h.children, function(c){ c.setAttribute('aria-hidden','true'); });

    // letters pop into colour on hover
    h.addEventListener('pointerover', function(e){
      var c = e.target.closest && e.target.closest('.kba-ch'); if (!c || RM || !h.classList.contains('kba-done')) return;
      c.style.color = pick(PAL); c.classList.remove('pop'); void c.offsetWidth; c.classList.add('pop');
    });
    h.addEventListener('animationend', function(e){ if (e.target.classList) e.target.classList.remove('pop'); });

    // the "boring" word gets painted, one letter at a time
    var accent = h.querySelectorAll('em .kba-ch');
    function paintAccent(){
      var doneAt = RM ? 0 : 400 + idx*28 + 900;
      setTimeout(function(){ h.classList.add('kba-done'); }, doneAt);
      Array.prototype.forEach.call(accent, function(c,i){ setTimeout(function(){ c.style.color = PAL[i % PAL.length]; if (!RM) c.classList.add('pop'); }, RM ? 0 : doneAt + 250 + i*130); });
    }

    // place tiles + confetti around the headline
    var tiles = Array.prototype.slice.call(hero.querySelectorAll('.kba-tile'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('.kba-dotc'));
    var shapes = ['28px','50%','44% 56% 62% 38%/42% 46% 54% 58%','999px 999px 28px 28px'];
    function place(){
      var w = hero.clientWidth, hh = hero.clientHeight, mob = w < 750, cr = hero.querySelector('.kba-hero__copy').getBoundingClientRect(), cw = Math.min(cr.width, w*.92), ch = cr.height;
      var count = mob ? Math.min(8, tiles.length) : tiles.length;
      tiles.forEach(function(el,i){
        if (i >= count){ el.style.display = 'none'; return; }
        el.style.display = '';
        var a = (i / count) * Math.PI * 2 - Math.PI/2 + rnd(-.2,.2);
        // on phones keep tiles in two bands above and below the copy
        if (mob){ var half = Math.ceil(count/2), top = i < half, j = top ? i : i - half, nn = top ? half : count - half; a = top ? Math.PI*(1.12 + .76*(j+.5)/nn) : Math.PI*(.88 - .76*(j+.5)/nn); }
        var s = mob ? rnd(70,96) : rnd(110, Math.min(184, w*.12));
        // push each tile just outside the headline box, then keep it on screen
        var ca = Math.cos(a), sa = Math.sin(a), m = s*.78 + rnd(0, mob ? 10 : 40);
        var bx = cw/2 + m, by = ch/2 + m*1.15;
        var k = 1 / Math.max(Math.abs(ca)/bx, Math.abs(sa)/by);
        var tx = clamp(ca*k, -w/2 + s*.55, w/2 - s*.55), ty = clamp(sa*k, -hh/2 + s*.7 + 10, hh/2 - s*.7 - 10);
        el.style.cssText += ';--x:'+tx.toFixed(0)+'px;--y:'+ty.toFixed(0)+'px;--r:'+rnd(-14,14).toFixed(1)+'deg;--s:'+s.toFixed(0)+'px;--z:'+rnd(.35,1.25).toFixed(2)+';--d:'+(i*55)+'ms;--br:'+shapes[i%shapes.length]+';--bd:-'+rnd(0,6).toFixed(1)+'s';
      });
      dots.forEach(function(el,i){
        var a = rnd(0, Math.PI*2);
        var s = mob ? rnd(10,26) : rnd(14,44);
        var ca = Math.cos(a), sa = Math.sin(a), bx = cw/2 + rnd(10,160), by = ch/2 + rnd(10,120);
        var k = 1 / Math.max(Math.abs(ca)/bx, Math.abs(sa)/by);
        var dx = clamp(ca*k, -w/2 + s, w/2 - s), dy = clamp(sa*k, -hh/2 + s + 20, hh/2 - s - 20);
        el.style.cssText += ';--x:'+dx.toFixed(0)+'px;--y:'+dy.toFixed(0)+'px;--r:'+rnd(-40,40).toFixed(0)+'deg;--s:'+s.toFixed(0)+'px;--z:'+rnd(.6,2).toFixed(2)+';--d:'+(200+i*45)+'ms;--dc:'+PAL[i%PAL.length];
      });
    }
    place();
    var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(place, 250); });
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-burst'); paintAccent(); }); });

    if (RM) return;
    // parallax with pointer + scroll
    if (FINE) hero.addEventListener('pointermove', function(e){
      var r = hero.getBoundingClientRect();
      hero.style.setProperty('--mx', (((e.clientX - r.left)/r.width) - .5).toFixed(3));
      hero.style.setProperty('--my', (((e.clientY - r.top)/r.height) - .5).toFixed(3));
    });
    var ticking = false;
    window.addEventListener('scroll', function(){
      if (ticking) return; ticking = true;
      requestAnimationFrame(function(){ ticking = false; var y = window.scrollY; if (y < window.innerHeight * 1.5) hero.style.setProperty('--sy', (y*.35).toFixed(0)); });
    }, {passive:true});

    // paint trail
    if (!FINE) return;
    var cv = hero.querySelector('.kba-trail'), cx = cv.getContext('2d'), blobs = [], running = false, dpr = Math.min(2, window.devicePixelRatio||1), last = 0;
    function size(){ cv.width = hero.clientWidth*dpr; cv.height = hero.clientHeight*dpr; }
    size(); window.addEventListener('resize', size);
    hero.addEventListener('pointermove', function(e){
      var now = performance.now(); if (now - last < 28) return; last = now;
      var r = hero.getBoundingClientRect();
      blobs.push({x:(e.clientX-r.left)*dpr, y:(e.clientY-r.top)*dpr, r:rnd(10,34)*dpr, c:pick(PAL), l:1});
      if (blobs.length > 90) blobs.shift();
      if (!running){ running = true; requestAnimationFrame(tick); }
    });
    function tick(){
      cx.clearRect(0,0,cv.width,cv.height);
      for (var i = blobs.length-1; i >= 0; i--){
        var b = blobs[i]; b.l -= .016; b.r *= 1.008;
        if (b.l <= 0){ blobs.splice(i,1); continue; }
        cx.globalAlpha = b.l * .55; cx.fillStyle = b.c; cx.beginPath(); cx.arc(b.x,b.y,b.r,0,Math.PI*2); cx.fill();
      }
      if (blobs.length) requestAnimationFrame(tick); else { running = false; cx.clearRect(0,0,cv.width,cv.height); }
    }
  })();

  /* ================= MANIFESTO ================= */
  (function mani(){
    var p = root.querySelector('.kba-mani__p'); if (!p) return;
    var special = {beige:'#d9c9a8', boring:'#c9cfd2', grey:'#c9cfd2'};
    var raw = p.getAttribute('data-raw') || p.textContent, pc = 0;
    p.innerHTML = '';
    raw.split(/\s+/).forEach(function(w, i){
      if (!w) return;
      var s = document.createElement('span'), pop = /^\*.+\*[^\s]*$/.test(w) || /^\*[^*]+\*$/.test(w);
      var txt = w.replace(/\*/g,'');
      s.className = 'kba-mani__w' + (pop ? ' kba-mani__w--pop' : '');
      if (pop){ var key = txt.toLowerCase().replace(/[^a-z]/g,''); s.style.setProperty('--wc', special[key] || PAL[pc++ % PAL.length]); }
      s.textContent = txt; p.appendChild(s); p.appendChild(document.createTextNode(' '));
    });
    var words = p.querySelectorAll('.kba-mani__w');
    if (RM){ Array.prototype.forEach.call(words, function(w){ w.classList.add('on'); }); return; }
    var lit = -1, tick = false;
    function update(){
      tick = false;
      var r = p.getBoundingClientRect(), vh = window.innerHeight;
      var prog = clamp((vh*.85 - r.top) / (r.height + vh*.35), 0, 1);
      var n = Math.round(prog * words.length);
      if (n === lit) return; lit = n;
      for (var i = 0; i < words.length; i++) words[i].classList.toggle('on', i < n);
    }
    window.addEventListener('scroll', function(){ if (!tick){ tick = true; requestAnimationFrame(update); } }, {passive:true});
    update();
  })();

  /* ================= 17 BOTTLES -> 1 BACKPACK ================= */
  (function morph(){
    var sec = root.querySelector('.kba-morph'); if (!sec) return;
    var stage = sec.querySelector('.kba-morph__stage'), cv = sec.querySelector('canvas'), ctx = cv.getContext('2d');
    var steps = sec.querySelectorAll('.kba-step'), sdots = sec.querySelectorAll('.kba-morph__dots span');
    var N = window.innerWidth < 750 ? 1300 : 2800;
    var W = 0, H = 0, dpr = 1, F = [], seeds = new Float32Array(N*4), cur = 0, target = 0, visible = false, raf = 0, active = -1, ready = false;
    for (var i = 0; i < N; i++){ seeds[i*4] = Math.random()*6.283; seeds[i*4+1] = rnd(.6,1.6); seeds[i*4+2] = rnd(.7,1.3); seeds[i*4+3] = Math.random(); }
    var PLASTIC = [[214,232,245],[168,201,232],[240,246,252],[138,178,220]];
    var YARN = [[246,245,243],[236,233,226],[255,255,255]];
    var BOTTLE = new Path2D('M38 28C38 28 35 35 35 42L35 48C25 52 18 60 18 70L18 155C18 165 28 170 50 170C72 170 82 165 82 155L82 70C82 60 75 52 65 48L65 42C65 35 62 28 62 28Z');
    var CAP = new Path2D(); CAP.rect(36,18,28,11);
    function box(){ return W < 750 ? {x:W*.08, y:H*.24, w:W*.84, h:H*.40} : {x:W*.40, y:H*.14, w:W*.50, h:H*.74}; }
    function randn(){ return (Math.random()+Math.random()+Math.random()+Math.random()-2)/2; }
    function pat(x, y, b, off){
      var s = b.w / 8.5, v = (x*.7 + y + Math.sin(x/(b.w*.09))*s*.55) / s;
      var k = (Math.floor(v) + (off||0)) % 6; if (k < 0) k += 6;
      // polka dots on every other band
      if (k % 2 === 0){ var gx = (x % (s*.55)) - s*.275, gy = (y % (s*.55)) - s*.275; if (gx*gx + gy*gy < s*s*.012) return [255,255,255]; }
      return PALRGB[k];
    }
    // draw a mask, then sample N points from it. r channel = main, g = secondary, b = detail
    function sample(draw, b, colour){
      var sc = Math.min(1, 520 / Math.max(b.w, b.h)), w = Math.max(10, Math.round(b.w*sc)), h = Math.max(10, Math.round(b.h*sc));
      var oc = document.createElement('canvas'); oc.width = w; oc.height = h;
      var o = oc.getContext('2d'); draw(o, w, h);
      var d = o.getImageData(0,0,w,h).data, cand = [];
      for (var y = 0; y < h; y += 1) for (var x = 0; x < w; x += 1){ var j = (y*w+x)*4; if (d[j+3] > 200) cand.push(x, y, d[j] > 128 ? 0 : d[j+1] > 128 ? 1 : 2); }
      var n = cand.length/3, pos = new Float32Array(N*2), col = new Float32Array(N*3);
      for (var i = 0; i < N; i++){
        var c = Math.floor(Math.random()*n)*3;
        var px = b.x + (cand[c] + Math.random()) / sc, py = b.y + (cand[c+1] + Math.random()) / sc;
        pos[i*2] = px; pos[i*2+1] = py;
        var rgb = colour(cand[c+2], px - b.x, py - b.y, i);
        col[i*3] = rgb[0]; col[i*3+1] = rgb[1]; col[i*3+2] = rgb[2];
      }
      return {p:pos, c:col};
    }
    function build(){
      var b = box(), mob = W < 750;
      // 0: seventeen bottles
      var rows = mob ? [5,5,4,3] : [6,6,5];
      var f0 = sample(function(o, w, h){
        var cw = w / rows[0], ch = h / rows.length, bh = Math.min(ch*.9, cw*.9*1.75), bw = bh/1.8, s = bh/165;
        rows.forEach(function(cnt, r){
          var ox = (w - cnt*cw)/2;
          for (var k = 0; k < cnt; k++){
            o.save(); o.translate(ox + k*cw + cw/2 - 50*s, r*ch + ch/2 - 95*s); o.scale(s,s);
            o.fillStyle = '#f00'; o.fill(BOTTLE); o.fillStyle = '#0f0'; o.fill(CAP); o.fillStyle = '#00f'; o.fillRect(18,96,64,26);
            o.restore();
          }
        });
      }, b, function(t){ return t === 1 ? PALRGB[0] : t === 2 ? [190,214,238] : pick(PLASTIC); });
      // 1: flakes – a shredded cloud
      var f1 = {p:new Float32Array(N*2), c:new Float32Array(N*3)};
      for (var i = 0; i < N; i++){
        var a = Math.random()*6.283, r = Math.pow(Math.random(), .6);
        f1.p[i*2] = b.x + b.w/2 + Math.cos(a)*r*b.w*.62 + randn()*20; f1.p[i*2+1] = b.y + b.h/2 + Math.sin(a)*r*b.h*.48 + randn()*20;
        var pc = pick(PLASTIC); f1.c[i*3] = pc[0]; f1.c[i*3+1] = pc[1]; f1.c[i*3+2] = pc[2];
      }
      // 2: yarn – twisting threads across the stage
      var f2 = {p:new Float32Array(N*2), c:new Float32Array(N*3)}, K = 5;
      for (i = 0; i < N; i++){
        var k = i % K, u = Math.random(), ph = k*1.3;
        var x = b.x - b.w*.1 + u*b.w*1.2;
        var y = b.y + b.h/2 + (k - (K-1)/2)*b.h*.07 + Math.sin(u*Math.PI*3 + ph)*b.h*.16;
        var tw = Math.sin(u*Math.PI*22 + ph)*4;
        f2.p[i*2] = x; f2.p[i*2+1] = y + tw + randn()*1.6;
        var yc = pick(YARN); f2.c[i*3] = yc[0]; f2.c[i*3+1] = yc[1]; f2.c[i*3+2] = yc[2];
      }
      // 3: printed fabric – a woven grid in full colour
      var f3 = {p:new Float32Array(N*2), c:new Float32Array(N*3)};
      var cols = Math.round(Math.sqrt(N * b.w / b.h)), rws = Math.ceil(N / cols);
      for (i = 0; i < N; i++){
        var cx = i % cols, cy = Math.floor(i / cols);
        var fx = (cx + .5) * b.w / cols, fy = (cy + .5) * b.h / rws;
        f3.p[i*2] = b.x + fx; f3.p[i*2+1] = b.y + fy;
        var pcl = pat(fx, fy, b, 0); f3.c[i*3] = pcl[0]; f3.c[i*3+1] = pcl[1]; f3.c[i*3+2] = pcl[2];
      }
      // 4: the backpack
      var f4 = sample(function(o, w, h){
        var s = Math.min(w/100, h/122), ox = (w - 100*s)/2, oy = (h - 122*s)/2;
        o.save(); o.translate(ox, oy); o.scale(s, s);
        o.fillStyle = '#f00'; o.beginPath(); if (o.roundRect) o.roundRect(12,22,76,98,[34,34,14,14]); else o.rect(12,22,76,98); o.fill();
        o.strokeStyle = '#0f0'; o.lineWidth = 6; o.lineCap = 'round'; o.beginPath(); o.moveTo(38,24); o.bezierCurveTo(38,4,62,4,62,24); o.stroke();
        o.fillStyle = '#0f0'; o.beginPath(); if (o.roundRect) o.roundRect(22,68,56,42,10); else o.rect(22,68,56,42); o.fill();
        o.fillStyle = '#00f'; o.fillRect(20,56,60,2.4); o.fillRect(22,66,56,2.2);
        o.restore();
      }, b, function(t, x, y){ return t === 0 ? pat(x, y, b, 0) : t === 1 ? pat(x, y, b, 3) : [255,255,255]; });
      F = [f0, f1, f2, f3, f4];
      ready = true;
    }
    var SIZE = [1.25, 1.7, .85, 1.25, 1.3], WOB = [.5, 7, 2.2, .6, .5];
    function ease(t){ return t < .5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3)/2; }
    function resize(){
      dpr = Math.min(2, window.devicePixelRatio || 1);
      W = stage.clientWidth; H = stage.clientHeight; cv.width = W*dpr; cv.height = H*dpr;
      build(); draw(performance.now());
    }
    function progress(){ var r = sec.getBoundingClientRect(); var span = r.height - window.innerHeight; return span > 0 ? clamp(-r.top / span, 0, 1) : 1; }
    function draw(now){
      if (!ready) return;
      ctx.setTransform(dpr,0,0,dpr,0,0); ctx.clearRect(0,0,W,H);
      var t = cur * 4, seg = Math.min(3, Math.floor(t)), local = t - seg, e = ease(clamp((local - .18) / .64, 0, 1));
      var A = F[seg], B = F[seg+1], mid = Math.sin(e*Math.PI), time = RM ? 0 : now*.001;
      var sz = (SIZE[seg] + (SIZE[seg+1]-SIZE[seg])*e) * (W < 750 ? 1.9 : 2.3), wob = WOB[seg] + (WOB[seg+1]-WOB[seg])*e;
      var lastStyle = '';
      for (var i = 0; i < N; i++){
        var i2 = i*2, i3 = i*3, i4 = i*4, ph = seeds[i4], sp = seeds[i4+1];
        var x = A.p[i2] + (B.p[i2]-A.p[i2])*e + Math.cos(ph)*mid*70*seeds[i4+2] + Math.sin(time*sp + ph)*wob;
        var y = A.p[i2+1] + (B.p[i2+1]-A.p[i2+1])*e + Math.sin(ph)*mid*70*seeds[i4+2] + Math.cos(time*sp*.8 + ph)*wob;
        var r = A.c[i3] + (B.c[i3]-A.c[i3])*e, g = A.c[i3+1] + (B.c[i3+1]-A.c[i3+1])*e, bl = A.c[i3+2] + (B.c[i3+2]-A.c[i3+2])*e;
        var st = 'rgb(' + (r|0) + ',' + (g|0) + ',' + (bl|0) + ')';
        if (st !== lastStyle){ ctx.fillStyle = st; lastStyle = st; }
        var s = sz * seeds[i4+2];
        ctx.fillRect(x - s/2, y - s/2, s, s);
      }
      var a = Math.min(4, Math.round(t));
      if (a !== active){
        active = a;
        for (var k = 0; k < steps.length; k++){ steps[k].classList.toggle('on', k === a); if (sdots[k]) sdots[k].classList.toggle('on', k === a); }
      }
    }
    function loop(now){
      target = progress();
      cur += (target - cur) * .09;
      if (Math.abs(target - cur) < .0004) cur = target;
      draw(now);
      raf = visible ? requestAnimationFrame(loop) : 0;
    }
    var rz; window.addEventListener('resize', function(){ clearTimeout(rz); rz = setTimeout(resize, 200); });
    if (RM){ resize(); cur = 1; draw(0); return; }
    if ('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ visible = e.isIntersecting; if (visible && !raf){ if (!ready) resize(); raf = requestAnimationFrame(loop); } }); }, {rootMargin:'200px 0px'}).observe(sec);
    } else { visible = true; resize(); raf = requestAnimationFrame(loop); }
  })();

  /* ================= COUNTER ================= */
  (function counter(){
    var el = root.querySelector('.kba-count__num'); if (!el) return;
    var rain = root.querySelectorAll('.kba-rain svg');
    Array.prototype.forEach.call(rain, function(s, i){ s.style.cssText = 'left:'+rnd(0,100).toFixed(1)+'%;--w:'+rnd(18,46).toFixed(0)+'px;--t:'+rnd(9,20).toFixed(1)+'s;--dl:-'+rnd(0,20).toFixed(1)+'s;--rot:'+rnd(-200,200).toFixed(0)+'deg'; });
    var n = parseInt(el.getAttribute('data-target'), 10); if (!n) return;
    var str = n.toLocaleString('en-GB'), digits = el.querySelector('.kba-count__digits');
    digits.innerHTML = '';
    var cols = [];
    str.split('').forEach(function(ch, i){
      var o = document.createElement('span');
      if (!/\d/.test(ch)){ o.className = 'kba-odo kba-odo--sep'; o.textContent = ch; digits.appendChild(o); return; }
      o.className = 'kba-odo'; var col = document.createElement('span');
      var spins = 2 + i % 3; // extra turns for a slot-machine feel
      for (var r = 0; r < spins; r++) for (var d = 0; d < 10; d++){ var b = document.createElement('b'); b.textContent = d; col.appendChild(b); }
      var fb = document.createElement('b'); fb.textContent = ch; col.appendChild(fb);
      col.style.setProperty('--dd', (i*70) + 'ms'); o.appendChild(col); digits.appendChild(o);
      cols.push({el:col, rows: spins*10});
    });
    function go(){ cols.forEach(function(c){ c.el.style.transform = 'translateY(-' + c.rows + 'em)'; }); }
    if (RM){ cols.forEach(function(c){ c.el.style.transition = 'none'; }); go(); return; }
    onView(el, function(){ setTimeout(go, 150); }, {threshold:.5});
  })();

  /* ================= COLOUR WALL ================= */
  (function wall(){
    var w = root.querySelector('.kba-wall'); if (!w) return;
    var rail = w.querySelector('.kba-rail'), cards = Array.prototype.slice.call(rail.querySelectorAll('.kba-card'));
    if (!cards.length){ w.style.display = 'none'; return; }
    cards.forEach(function(c, i){ var col = PAL[(i+1) % PAL.length]; c.dataset.c = col; c.style.setProperty('--cc', col); });
    var mid = null, tk = false;
    function centre(){
      tk = false;
      var rr = rail.getBoundingClientRect(), cxm = rr.left + rr.width/2, best = null, bd = 1e9;
      cards.forEach(function(c){ var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width/2 - cxm); if (d < bd){ bd = d; best = c; } });
      if (best && best !== mid){ if (mid) mid.classList.remove('is-mid'); mid = best; mid.classList.add('is-mid'); w.style.setProperty('--wall', best.dataset.c); }
    }
    rail.addEventListener('scroll', function(){ if (!tk){ tk = true; requestAnimationFrame(centre); } }, {passive:true});
    centre();
    w.querySelectorAll('.kba-wall__nav button').forEach(function(b){
      b.addEventListener('click', function(){ var step = cards[0].getBoundingClientRect().width + 22; rail.scrollBy({left: step * parseInt(b.dataset.dir,10) * (window.innerWidth < 750 ? 1 : 2), behavior: RM ? 'auto' : 'smooth'}); });
    });
    if (!FINE) return;
    // drag to scroll with a little momentum
    var down = false, sx = 0, sl = 0, moved = false, vx = 0, lx = 0, lt = 0;
    rail.addEventListener('pointerdown', function(e){ if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; sx = lx = e.clientX; sl = rail.scrollLeft; lt = performance.now(); vx = 0; });
    window.addEventListener('pointermove', function(e){
      if (!down) return; var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 6){ moved = true; rail.classList.add('is-drag'); }
      if (moved){ rail.scrollLeft = sl - dx; var now = performance.now(); vx = (e.clientX - lx) / Math.max(1, now - lt); lx = e.clientX; lt = now; }
    });
    window.addEventListener('pointerup', function(){
      if (!down) return; down = false;
      if (moved){
        var v = vx * 16;
        (function glide(){ if (Math.abs(v) < .5 || RM){ rail.classList.remove('is-drag'); return; } rail.scrollLeft -= v; v *= .93; requestAnimationFrame(glide); })();
      }
    });
    rail.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    rail.addEventListener('dragstart', function(e){ e.preventDefault(); });
    // tilt
    if (RM) return;
    cards.forEach(function(c){
      c.addEventListener('pointermove', function(e){ var r = c.getBoundingClientRect(); c.style.setProperty('--ry', (((e.clientX - r.left)/r.width - .5)*14).toFixed(1)+'deg'); c.style.setProperty('--rx', ((.5 - (e.clientY - r.top)/r.height)*12).toFixed(1)+'deg'); });
      c.addEventListener('pointerleave', function(){ c.style.setProperty('--rx','0deg'); c.style.setProperty('--ry','0deg'); });
    });
  })();

  /* ================= RECEIPTS ================= */
  (function proof(){
    var flips = root.querySelectorAll('.kba-flip'); if (!flips.length) return;
    Array.prototype.forEach.call(flips, function(f){
      f.addEventListener('click', function(){ var on = !f.classList.contains('is-flipped'); f.classList.toggle('is-flipped', on); f.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    });
    var grid = root.querySelector('.kba-proof__grid');
    if (RM){ Array.prototype.forEach.call(flips, function(f){ f.classList.add('is-in'); }); return; }
    onView(grid, function(){ Array.prototype.forEach.call(flips, function(f){ f.classList.add('is-in'); }); }, {threshold:.15});
  })();

  /* ================= SURPRISE ME ================= */
  (function cta(){
    var sec = root.querySelector('.kba-cta'); if (!sec) return;
    var btn = sec.querySelector('.kba-surprise'), card = sec.querySelector('.kba-pick'), list = [];
    try { list = JSON.parse(sec.querySelector('.kba-products').textContent).filter(function(p){ return p && p.u; }); } catch(e){}
    if (!list.length){ btn.style.display = 'none'; return; }
    var lastI = -1;
    function confetti(){
      if (RM) return;
      var br = btn.getBoundingClientRect(), sr = sec.getBoundingClientRect();
      for (var i = 0; i < 46; i++){
        var c = document.createElement('i'); c.className = 'kba-conf';
        var a = rnd(0, Math.PI*2), d = rnd(120, 420);
        c.style.cssText = 'left:'+(br.left - sr.left + br.width/2)+'px;top:'+(br.top - sr.top + br.height/2)+'px;--cc:'+pick(PAL)+';--rr:'+pick(['50%','2px','50% 0'])+';--dx:'+(Math.cos(a)*d).toFixed(0)+'px;--dy:'+(Math.sin(a)*d - 80).toFixed(0)+'px;--rot:'+rnd(-540,540).toFixed(0)+'deg;width:'+rnd(8,16).toFixed(0)+'px;height:'+rnd(8,16).toFixed(0)+'px';
        sec.appendChild(c);
        setTimeout(function(n){ return function(){ n.remove(); }; }(c), 1400);
      }
    }
    btn.addEventListener('click', function(){
      var i; do { i = Math.floor(Math.random()*list.length); } while (list.length > 1 && i === lastI); lastI = i;
      var p = list[i];
      card.href = p.u; card.querySelector('img').src = p.i; card.querySelector('img').alt = p.t;
      card.querySelector('b').textContent = p.t; card.querySelector('small').textContent = p.p;
      card.hidden = false; card.classList.remove('is-new'); void card.offsetWidth; card.classList.add('is-new');
      confetti();
    });
  })();
}
function boot(){ Array.prototype.forEach.call(document.querySelectorAll('.kba'), kbaInit); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
